import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "watchlist_container watchlist_post_container bg-dark-container",
  ref: "col_watchlist"
}
const _hoisted_2 = {
  key: 0,
  class: "watchlist_table_body"
}
const _hoisted_3 = { class: "wathlistScrollContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PredictionCardItem = _resolveComponent("PredictionCardItem")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_ctx.postModel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.postModel.prediction.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_scrollbar, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postModel.prediction, (item) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "predicition-post-card",
                        key: item.predictionId
                      }, [
                        _createVNode(_component_PredictionCardItem, {
                          class: "cursor-pointer",
                          postId: _ctx.postModel._id,
                          trade: item,
                          disableRouting: false
                        }, null, 8, ["postId", "trade"])
                      ]))
                    }), 128))
                  ])
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}